/* lua.js generated code undefined */

let TileMint = xClass("TileMint", cc.Node)
let offsetX = 70
let offsetY = 70
let BUBBLENAME = table(
    "bubble_small_anima",
    "bubble_big_anima",
    "kuo_anime",
    "shou"
)
let RoadTypeConfig = table(
    [1, RoadCornerType.kStart_R, table(
        [1, "spName", "cocos/mintRow_top_anime_heng.csb"],
        [1, "shadow", "cocos/mintRow_top_anime_heng_shadow.csb"],
        [1, "rotation", 0]
    )],
    [1, RoadCornerType.kStart_L, table(
        [1, "spName", "cocos/mintRow_top_anime_heng.csb"],
        [1, "shadow", "cocos/mintRow_top_anime_heng_shadow.csb"],
        [1, "rotation", 180]
    )],
    [1, RoadCornerType.kStart_U, table(
        [1, "spName", "cocos/mint_top_animation.csb"],
        [1, "shadow", "cocos/mint_top_animation_shadow.csb"],
        [1, "rotation", 0]
    )],
    [1, RoadCornerType.kStart_D, table(
        [1, "spName", "cocos/mint_top_animation.csb"],
        [1, "shadow", "cocos/mint_top_animation_shadow.csb"],
        [1, "rotation", 180]
    )],
    [1, RoadCornerType.kEnd_R, table(
        [1, "spName", "cocos/mintRow_end_anime_heng.csb"],
        [1, "shadow", "cocos/mintRow_end_anime_heng_shadow.csb"],
        [1, "rotation", 180]
    )],
    [1, RoadCornerType.kEnd_L, table(
        [1, "spName", "cocos/mintRow_end_anime_heng.csb"],
        [1, "shadow", "cocos/mintRow_end_anime_heng_shadow.csb"],
        [1, "rotation", 0]
    )],
    [1, RoadCornerType.kEnd_U, table(
        [1, "spName", "cocos/mint_end_animation.csb"],
        [1, "shadow", "cocos/mint_end_animation_shadow.csb"],
        [1, "rotation", 180]
    )],
    [1, RoadCornerType.kEnd_D, table(
        [1, "spName", "cocos/mint_end_animation.csb"],
        [1, "shadow", "cocos/mint_end_animation_shadow.csb"],
        [1, "rotation", 0]
    )],
    [1, RoadCornerType.kHorizontal, table(
        [1, "spName", "cocos/mintRow_mid_anime_heng.csb"],
        [1, "shadow", "cocos/mintRow_mid_anime_heng_shadow.csb"],
        [1, "rotation", 0]
    )],
    [1, RoadCornerType.kVertical, table(
        [1, "spName", "cocos/mint_mid_animation.csb"],
        [1, "shadow", "cocos/mint_mid_animation_shadow.csb"],
        [1, "rotation", 0]
    )]
)
getRoadType = function (spotType, dir) {
    let roadType = RoadCornerType.kNone
    if (spotType === "head") { //head
        if (dir === GameItemDirection.kUp) {
            roadType = RoadCornerType.kStart_U
        } else if (dir === GameItemDirection.kDown) {
            roadType = RoadCornerType.kStart_D
        } else {
            roadType = RoadCornerType.kStart_R
            if (dir === GameItemDirection.kLeft) {
                roadType = RoadCornerType.kStart_L
            }
        }
    } else if (spotType === "tail") { //tail
        if (dir === GameItemDirection.kUp) {
            roadType = RoadCornerType.kEnd_D
        } else if (dir === GameItemDirection.kDown) {
            roadType = RoadCornerType.kEnd_U
        } else if (dir === GameItemDirection.kRight) {
            roadType = RoadCornerType.kEnd_L
        } else {
            roadType = RoadCornerType.kEnd_R
        }
    } else { //body
        if (spotType === "body") {
            if (dir === GameItemDirection.kUp || dir === GameItemDirection.kDown) {
                roadType = RoadCornerType.kVertical
            } else {
                roadType = RoadCornerType.kHorizontal
            }
        }
    }
    return roadType
}
// 预填充对象池
TileMint.prototype.prefillAnimationCachePool = function () {
    let mintCfg = TileMint.prefillAniMapData
    let gameMode = TileMint.prefillAniGameMode
    if (!mintCfg || !gameMode) {
        return 
    }
    let prefillNum = 2
    if (gameMode === GamePlayType.kWaterDig) {
        prefillNum = 4
    }
    for (let _ = 1, cfg = mintCfg[1]; cfg; _++, cfg = mintCfg[_]) {
        let pathData = table()
        let pe = cfg.pathElements[1]
        let startPos = table([1, "x", pe[1]], [1, "y", pe[2]])
        let endPos = table([1, "x", pe[3]], [1, "y", pe[4]])
        if (startPos.x === endPos.x) {
            let step = (endPos.y - startPos.y) / Math.abs(endPos.y - startPos.y)
            let $var17 = startPos.y,$limit18 = endPos.y,$step19 = step
            for (let i = $var17; ($step19 > 0 && i <= $limit18) || ($step19 < 0 && i >= $limit18); i += $step19) {
                table.insert(pathData, table([1, "x", startPos.x], [1, "y", i]))
            }
        } else {
            let step = (endPos.x - startPos.x) / Math.abs(endPos.x - startPos.x)
            let $var21 = startPos.x,$limit22 = endPos.x,$step23 = step
            for (let i = $var21; ($step23 > 0 && i <= $limit22) || ($step23 < 0 && i >= $limit22); i += $step23) {
                table.insert(pathData, table([1, "x", i], [1, "y", startPos.y]))
            }
        }
        cc.log("startPos(" + startPos.x + ", " + startPos.y + ") endPos(" + endPos.x + ", " + endPos.y + ")")
        let dir = GameItemDirection.kNone
        if (startPos.y === endPos.y && startPos.x < endPos.x) {
            dir = GameItemDirection.kRight
        } else if (startPos.y === endPos.y && startPos.x > endPos.x) {
            dir = GameItemDirection.kRight
        } else if (startPos.x === endPos.x && startPos.y < endPos.y) {
            dir = GameItemDirection.kUp
        } else if (startPos.x === endPos.x && startPos.y > endPos.y) {
            dir = GameItemDirection.kUp
        }
        let roadType = RoadCornerType.kNone
        let $limit27 = $len(pathData)
        for (let i = 1; i <= $limit27; i += 1) {
            if (i === 1) {
                roadType = getRoadType("head", dir)
            } else if (i === $len(pathData)) {
                roadType = getRoadType("tail", dir)
            } else {
                roadType = getRoadType("body", dir)
            }
            let config = RoadTypeConfig[roadType]
            let fillNum = 1
            if (config) {
                cc.log("Prefill csb: " + config.spName + " " + config.shadow)
                AnimationCachePool.getInstance().fill(config.spName, prefillNum)
                AnimationCachePool.getInstance().fill(config.shadow, prefillNum)
                for (let _ in BUBBLENAME) {
                    let ani = BUBBLENAME[_]
                    if ($null(ani)) continue
                    let csb = "cocos/mint_" + ani + ".csb"
                    AnimationCachePool.getInstance().fill(csb, prefillNum)
                }
                AnimationCachePool.getInstance().fill("cocos/mint_star_pipe_vfx.csb", 1)
            }
        }
    }
}
TileMint.prototype.ctor = function (data) {
    let self = this
    cc.Node.prototype.ctor.call(self)
    self.cacheCsbNodes = table()
    self.dir = GameItemDirection.kNone
    self.offsetX = 0
    self.offsetY = 0
    self.data = data
    self.init(data)
    self.setCascadeOpacityEnabled(true)
}
TileMint.prototype.init = function (data) {
    let self = this
    let pathData = data.pathData
    if (null == pathData) {
        return
    }
    self.parseRoutesData(data)
    self.addContainer()
    let totalLength = $len(pathData) + 1
    let $limit10 = $len(pathData) + 1
    for (let i = 1; i <= $limit10; i += 1) {
        if (i === 1) {
            self.addHeadView(null, true)
        } else if (i === totalLength) {
            self.addTailView(i, true)
        } else {
            self.addBodyView(pathData[i], i, true)
        }
    }
    
    self.updateLua(data.strength, totalLength)
}
TileMint.prototype.updateLua = function (currentStrength, totalLength) {
    let self = this
    if (currentStrength === totalLength) {
        return 
    }
    let dur = totalLength - currentStrength
    let $limit15 = dur
    for (let i = 1; i <= $limit15; i += 1) {
        let sp
        if (i === 1) {
            sp = self.container.head
        } else {
            sp = self.container.body[i]
        }
        sp.actionTimeLine.gotoFrameAndPause(34)
        let v = "bubble_small_anima"
        function show(node) {
            node.getChildByName(v + "_holder").v.setVisible(true)
            node.getChildByName(v + "_holder").v.actionTimeLine.gotoFrameAndPlay(0, true)
        }
        if (sp.getChildByName(v + "_holder") && sp.getChildByName(v + "_holder").v) {
            show(sp)
        } else {
            self.addBubbleSmallPart(sp)
            show(sp)
        }
    }
}
TileMint.prototype.parseRoutesData = function (data) {
    let self = this
    let rt = data.routes
    if (rt) {
        if (rt.startPos.x === rt.endPos.x && rt.startPos.y < rt.endPos.y) {
            self.offsetX = $len(data.pathData) * GamePlayConfig_Tile_Width
            self.dir = GameItemDirection.kRight
        } else if (rt.startPos.x === rt.endPos.x && rt.startPos.y > rt.endPos.y) {
            self.dir = GameItemDirection.kRight
        } else if (rt.startPos.y === rt.endPos.y && rt.startPos.x < rt.endPos.x) {
            self.offsetY = -$len(data.pathData) * GamePlayConfig_Tile_Height
            self.dir = GameItemDirection.kUp
        } else if (rt.startPos.y === rt.endPos.y && rt.startPos.x > rt.endPos.x) {
            self.dir = GameItemDirection.kUp
        }
    }
    self.data.dir = self.dir
}
TileMint.prototype.addContainer = function () {
    let self = this
    let container = cc.Node.create()
    self.addChild(container)
    self.container = container
}
TileMint.prototype.addHeadView = function (data, needAddBubble) {
    let self = this
    let roadType = self.getRoadType("head")
    let sprite = self.getSpriteRoad(roadType)
    sprite.setCascadeOpacityEnabled(true)
    self.container.addChild(sprite)
    self.container.addChild(sprite.shadow, -1)
    if (needAddBubble) {
        self.addBubblePart(sprite)
    } else {
        self.addBubbleBigPart(sprite)
    }
    sprite.setPosition(self.offsetX, self.offsetY)
    sprite.shadow.setPosition(self.offsetX, self.offsetY)
    self.container.head = sprite
}
TileMint.prototype.addBodyView = function (pathData, idx, needAddBubble) {
    let self = this
    if (!self.container.body) {
        self.container.body = table()
    }
    let [s_x, s_y] = self.getCoefficientByDir()
    let posX = (idx - 1) * s_x * GamePlayConfig_Tile_Width
    let posY = (idx - 1) * s_y * GamePlayConfig_Tile_Height
    let roadType = self.getRoadType("body")
    let sprite = self.getSpriteRoad(roadType)
    sprite.setCascadeOpacityEnabled(true)
    self.container.addChild(sprite)
    self.container.addChild(sprite.shadow, -1)
    if (needAddBubble) {
        self.addBubblePart(sprite, true)
    } else {
        self.addBubbleBigPart(sprite)
    }
    sprite.setPosition(cc.p(posX + self.offsetX, posY + self.offsetY))
    sprite.shadow.setPosition(cc.p(posX + self.offsetX, posY + self.offsetY))
    self.container.body[idx] = sprite
}
TileMint.prototype.addTailView = function (cnt, needAddBubble) {
    let self = this
    let [s_x, s_y] = self.getCoefficientByDir()
    let posX = (cnt - 1) * s_x * GamePlayConfig_Tile_Width
    let posY = (cnt - 1) * s_y * GamePlayConfig_Tile_Height
    let roadType = self.getRoadType("tail")
    let sprite = self.getSpriteRoad(roadType)
    sprite.setCascadeOpacityEnabled(true)
    self.container.addChild(sprite)
    self.container.addChild(sprite.shadow, -1)
    self.container.tail = sprite
    if (needAddBubble) {
        self.addBubblePart(sprite)
    } else {
        self.addBubbleBigPart(sprite)
    }
    sprite.setPosition(cc.p(posX + self.offsetX, posY + self.offsetY))
    sprite.shadow.setPosition(cc.p(posX + self.offsetX, posY + self.offsetY))
}

TileMint.prototype.getRoadType = function (spotType) {
    let self = this
    let roadType = RoadCornerType.kNone
    if (spotType === "head") { //head
        if (self.dir === GameItemDirection.kUp) {
            roadType = RoadCornerType.kStart_U
        } else if (self.dir === GameItemDirection.kDown) {
            roadType = RoadCornerType.kStart_D
        } else {
            roadType = RoadCornerType.kStart_R
            if (self.dir === GameItemDirection.kLeft) {
                roadType = RoadCornerType.kStart_L
            }
        }
    } else if (spotType === "tail") { //tail
        if (self.dir === GameItemDirection.kUp) {
            roadType = RoadCornerType.kEnd_D
        } else if (self.dir === GameItemDirection.kDown) {
            roadType = RoadCornerType.kEnd_U
        } else if (self.dir === GameItemDirection.kRight) {
            roadType = RoadCornerType.kEnd_L
        } else {
            roadType = RoadCornerType.kEnd_R
        }
    } else { //body
        if (spotType === "body") {
            if (self.dir === GameItemDirection.kUp || self.dir === GameItemDirection.kDown) {
                roadType = RoadCornerType.kVertical
            } else {
                roadType = RoadCornerType.kHorizontal
            }
        }
    }
    return roadType
}
TileMint.prototype.addBubblePart = function (sp, isBody) {
    let self = this
    for (let k = 1, v = BUBBLENAME[1]; v; k++, v = BUBBLENAME[k]) {
        if (sp.getChildByName(v + "_holder")) {
            let animateNode = AnimationCachePool.getInstance().getAnimation("cocos/mint_" + v + ".csb")
            table.insert(self.cacheCsbNodes, animateNode)
            sp.getChildByName(v + "_holder").addChild(animateNode)
            if (isBody && self.dir === GameItemDirection.kRight && v === "bubble_small_anima") {
                animateNode.setPosition(cc.p(GamePlayConfig_Tile_Width / 2 + 15, GamePlayConfig_Tile_Height / 2 + 15))
            } else {
                animateNode.setPosition(cc.p(GamePlayConfig_Tile_Width / 2 + 15, GamePlayConfig_Tile_Height / 2 + 15))
            }
            sp.getChildByName(v + "_holder").v = animateNode
            animateNode.setVisible(false)
        }
    }
}
TileMint.prototype.addBubbleBigPart = function (sp) {
    let self = this
    let v = "bubble_big_anima"
    if (sp.getChildByName(v + "_holder")) {
        let animateNode = AnimationCachePool.getInstance().getAnimation("cocos/mint_" + v + ".csb")
        table.insert(self.cacheCsbNodes, animateNode)
        sp.getChildByName(v + "_holder").addChild(animateNode)
        animateNode.setPosition(cc.p(GamePlayConfig_Tile_Width / 2 + 15, GamePlayConfig_Tile_Height / 2 + 15))
        sp.getChildByName(v + "_holder").v = animateNode
        animateNode.setVisible(false)
    }
}
TileMint.prototype.addBubbleSmallPart = function (sp) {
    let self = this
    let v = "bubble_small_anima"
    if (sp.getChildByName(v + "_holder")) {
        let animateNode = AnimationCachePool.getInstance().getAnimation("cocos/mint_" + v + ".csb")
        table.insert(self.cacheCsbNodes, animateNode)
        sp.getChildByName(v + "_holder").addChild(animateNode)
        if (self.dir === GameItemDirection.kRight) {
            animateNode.setPosition(cc.p(GamePlayConfig_Tile_Width / 2 + 15, GamePlayConfig_Tile_Height / 2 + 15))
        } else {
            animateNode.setPosition(cc.p(GamePlayConfig_Tile_Width / 2 + 15, GamePlayConfig_Tile_Height / 2 + 15))
        }
        sp.getChildByName(v + "_holder").v = animateNode
        animateNode.setVisible(false)
    }
}
TileMint.prototype.getCoefficientByDir = function () {
    let self = this
    let [paramX, paramY] = [0, 0]
    if (self.dir === GameItemDirection.kUp) {
        ;[paramX, paramY] = [0, 1]
    } else if (self.dir === GameItemDirection.kDown) {
        ;[paramX, paramY] = [0, -1]
    } else if (self.dir === GameItemDirection.kLeft) {
        ;[paramX, paramY] = [1, 0]
    } else {
        ;[paramX, paramY] = [-1, 0]
    }
    // FIXME: multi result
    return [paramX, paramY]
}
TileMint.prototype.getSpriteRoad = function (roadType) {
    let self = this
    // body
    let config = RoadTypeConfig[roadType]
    let sp = AnimationCachePool.getInstance().getAnimation(config.spName)
    table.insert(self.cacheCsbNodes, sp)
    let rotation = config.rotation
    sp.actionTimeLine.gotoFrameAndPause(23)
    let shadow = AnimationCachePool.getInstance().getAnimation(config.shadow)
    table.insert(self.cacheCsbNodes, shadow)
    sp.shadow = shadow
    sp.setRotation(config.rotation)
    sp.shadow.setRotation(config.rotation)
    sp.setScale(1.01)
    return sp
}
TileMint.prototype.playMintDestroy = function () {
    let self = this
    let sp, sp_type
    let length = $len(self.data.pathData) + 1
    let dur = length - self.data.strength
    if (dur === 1) {
        sp = self.container.head
        sp_type = "head"
    } else if (dur === $len(self.data.pathData) + 1) {
        sp = self.container.tail
        sp_type = "tail"
    } else {
        sp = self.container.body[dur]
    }
    self.playMintIncrease(sp, sp_type, dur)
}
TileMint.prototype.playMintIncrease = function (sp, sp_type, dur) {
    let self = this
    let newSp
    sp.shadow.removeFromParent(false)
    AnimationCachePool.getInstance().backAnimationToPool(sp.shadow)
    sp.removeFromParent(false)
    AnimationCachePool.getInstance().backAnimationToPool(sp)
    if (sp_type === "head") {
        self.addHeadView(null, true)
        newSp = self.container.head
    } else if (sp_type === "tail") {
        let length = $len(self.data.pathData) + 1
        self.addTailView(length, true)
        newSp = self.container.tail
    } else {
        self.addBodyView(null, dur, true)
        newSp = self.container.body[dur]
    }
    self.playAnimateByIdle(newSp, "change", sp_type === "tail")
}
TileMint.prototype.playAnimateByIdle = function (sp, name, isTail) {
    let self = this
    if (isTail && name === "ready") {
        sp.actionTimeLine.play("ready+change", false)
    } else if (name === "change") {
        function sendCallFunc() {
            if (!sp.actionTimeLine) {
                return 
            }
            sp.actionTimeLine.play(name, false)
        }
        self.playPreMint(sendCallFunc)
    } else {
        sp.actionTimeLine.play(name, false)
    }
    if (name === "change") {
        function sendShadowCallFunc() {
            if (!sp.shadow) {
                return 
            }
            sp.shadow.actionTimeLine.play(name, false)
        }
        self.playPreShadow(sendShadowCallFunc)
    } else {
        sp.shadow.actionTimeLine.play(name, false)
    }
    if (name === "ready") {
        self.playLoopAni(sp.actionTimeLine, isTail)
        self.playLoopAni(sp.shadow.actionTimeLine)
    }
    for (let k = 1, v = BUBBLENAME[1]; v; k++, v = BUBBLENAME[k]) {
        if (sp.getChildByName(v + "_holder")) {
            let parent = sp.getChildByName(v + "_holder")
            if (parent.v && ((v !== "bubble_big_anima" && name === "change") || (v === "bubble_big_anima" && name === "ready"))) {
                let beLoop = false
                parent.v.setVisible(true)
                if (v === "bubble_big_anima" || v === "bubble_small_anima") {
                    beLoop = true
                }
                parent.v.actionTimeLine.gotoFrameAndPlay(0, beLoop)
                if (!beLoop) {
                    parent.v.actionTimeLine.setLastFrameCallFunc(function () {
                        parent.v.actionTimeLine.clearLastFrameCallFunc()
                        parent.v.removeFromParent(false)
                        AnimationCachePool.getInstance().backAnimationToPool(parent.v)
                        parent.v = null
                    })
                }
            }
        }
    }
}
TileMint.prototype.playPreMint = function (callBack) {
    let self = this
    let length = $len(self.data.pathData) + 1
    let dur = length - self.data.strength
    if (dur <= 1) {
        if (callBack) {
            callBack()
        }
        return 
    }
    // local delay = 0
    let $limit81 = length
    for (let i = 1; i <= $limit81; i += 1) {
        // self:runAction(cc.Sequence:create(
        // 	cc.DelayTime:create(delay),
        // cc.CallFunc:create(function()
        if (i === dur) {
            if (callBack) {
                callBack()
            }
        } else if (i < dur) {
            let sp = i === 1 && self.container.head || self.container.body[i]
            if (!sp) {
                sp = self.container.tail
            }
            sp.actionTimeLine.play("send_1", false)
            sp.actionTimeLine.setLastFrameCallFunc(function () {
                let __VA_ARG = $slice(arguments, 0)
                sp.actionTimeLine.clearLastFrameCallFunc()
                sp.actionTimeLine.gotoFrameAndPause(34)
            })
        } else {
            let sp = i === 1 && self.container.head || self.container.body[i]
            if (!sp) {
                sp = self.container.tail
            }
            sp.actionTimeLine.play("send_0", false)
        }
        // 	end)
        // ))
        // delay = delay + 0
    }
}
TileMint.prototype.playPreShadow = function (callBack) {
    let self = this
    let length = $len(self.data.pathData) + 1
    let dur = length - self.data.strength
    if (dur <= 1) {
        return 
    }
    let delay = 0
    let $limit90 = length
    for (let i = 1; i <= $limit90; i += 1) {
        // self:runAction(cc.Sequence:create(
        // 	cc.DelayTime:create(delay),
        // 	cc.CallFunc:create(function()
        if (i === dur) {
            if (callBack) {
                callBack()
            }
        } else {
            let sp = i === 1 && self.container.head || self.container.body[i]
            if (!sp) {
                sp = self.container.tail
            }
            sp.shadow.actionTimeLine.play("send", false)
        }
        // 	end)
        // ))
        // delay = delay + 0
    }
}
TileMint.prototype.playLoopAni = function (actionTimeLine, isTail) {
    let self = this
    if (isTail) {
        actionTimeLine.setLastFrameCallFunc(function () {
            actionTimeLine.clearLastFrameCallFunc()
            actionTimeLine.play("loop", true)
            let $limit95 = $len(self.data.pathData)
            for (let i = 1; i <= $limit95; i += 1) {
                let sp = i === 1 && self.container.head || self.container.body[i]
                if (sp) {
                    sp.actionTimeLine.play("loop", true)
                }
            }
        })
    } else {
        actionTimeLine.setLastFrameCallFunc(function () {
            actionTimeLine.clearLastFrameCallFunc()
            actionTimeLine.play("loop", true)
        })
    }
}
TileMint.prototype.removeMintBlock = function () {
    let self = this
    self.container.runAction(cc.Sequence.create(cc.Spawn.create(cc.EaseSineIn.create(cc.MoveBy.create(0.3, cc.p(0, -50))), cc.CallFunc.create(function () {
        self.playFadeOut()
    })), cc.RemoveSelf.create()))
}
TileMint.prototype.removeMintBlockImmediate = function () {
    let self = this
    self.container.runAction(cc.RemoveSelf.create())
}
TileMint.prototype.playFadeOut = function () {
    let self = this
    self.container.head.shadow.runAction(cc.FadeOut.create(0.3))
    self.container.head.runAction(cc.FadeOut.create(0.3))
    self.container.tail.shadow.runAction(cc.FadeOut.create(0.3))
    self.container.tail.runAction(cc.FadeOut.create(0.3))
    let $st100 = self.container.body || table()
    for (let _ in $st100) {
        let sp = $st100[_]
        if ($null(sp)) continue
        sp.shadow.runAction(cc.FadeOut.create(0.3))
        sp.runAction(cc.FadeOut.create(0.3))
    }
}
TileMint.prototype.playReadySpray = function () {
    let self = this
    self.playAnimation("ready")
    self.readyInstance = MusicPlayer.playEffect(GameMusicType.kMintReady)
}
TileMint.prototype.playAnimation = function (name) {
    let self = this
    self.container.head.shadow.removeFromParent(false)
    AnimationCachePool.getInstance().backAnimationToPool(self.container.head.shadow)
    self.container.head.removeFromParent(false)
    AnimationCachePool.getInstance().backAnimationToPool(self.container.head)
    self.container.tail.shadow.removeFromParent(false)
    AnimationCachePool.getInstance().backAnimationToPool(self.container.tail.shadow)
    self.container.tail.removeFromParent(false)
    AnimationCachePool.getInstance().backAnimationToPool(self.container.tail)
    let $st104 = self.container.body || table()
    for (let _ in $st104) {
        let sp = $st104[_]
        if ($null(sp)) continue
        sp.shadow.removeFromParent(false)
        AnimationCachePool.getInstance().backAnimationToPool(sp.shadow)
        sp.removeFromParent(false)
        AnimationCachePool.getInstance().backAnimationToPool(sp)
    }
    let pathData = self.data.pathData
    let $limit108 = $len(pathData) + 1
    for (let i = 1; i <= $limit108; i += 1) {
        if (i === 1) {
            self.addHeadView(null, false)
            self.playAnimateByIdle(self.container.head, name)
        } else if (i === $len(pathData) + 1) {
            self.addTailView(i, false)
            self.playAnimateByIdle(self.container.tail, name, true)
        } else {
            self.addBodyView(pathData[i], i, false)
            let sp = self.container.body[i]
            self.playAnimateByIdle(sp, name)
        }
    }
    if (name === "release") {
        self.playStarAni()
    }
}
TileMint.prototype.__playAnimation = function (name) {
    let self = this
    let length = $len(self.data.pathData) + 1
    let delay = 0
    let $limit115 = length
    for (let i = 1; i <= $limit115; i += 1) {
        self.runAction(cc.Sequence.create(cc.DelayTime.create(delay), cc.CallFunc.create(function () {
            if (i === 1) {
                self.playAnimateByIdle(self.container.head, name)
            } else if (i < length) {
                let sp = self.container.body[i]
                if (sp) {
                    self.playAnimateByIdle(sp, name)
                }
            } else {
                self.playAnimateByIdle(self.container.tail, name)
            }
        })))
        delay = delay + 0.03
    }
}
TileMint.prototype.playStarAni = function () {
    let self = this
    let length = $len(self.data.pathData) + 1
    let $limit121 = length
    for (let i = 1; i <= $limit121; i += 1) {
        let sp
        if (i === 1) {
            sp = self.container.head
        } else if (i < length) {
            sp = self.container.body[i]
        } else {
            sp = self.container.tail
        }
        self.addStarFx(sp)
    }
}
TileMint.prototype.playReleaseAni = function (callBack) {
    let self = this
    self.playAnimation("release")
    let sp = self.container.head
    sp.actionTimeLine.setLastFrameCallFunc(function () {
        sp.actionTimeLine.clearLastFrameCallFunc()
        self.__playAnimation("line_fx")
    })
}
TileMint.prototype.addStarFx = function (sp) {
    let self = this
    if (!sp) {
        return 
    }
    let animateNode = AnimationCachePool.getInstance().getAnimation("cocos/mint_star_pipe_vfx.csb")
    table.insert(self.cacheCsbNodes, animateNode)
    let v = "bubble_big_anima"
    sp.addChild(animateNode)
    animateNode.setPosition(cc.p(GamePlayConfig_Tile_Width / 2 - 35, GamePlayConfig_Tile_Height / 2 - 35))
    animateNode.setScale(1.2)
    animateNode.actionTimeLine.gotoFrameAndPlay(0, false)
    animateNode.actionTimeLine.setLastFrameCallFunc(function () {
        animateNode.actionTimeLine.clearLastFrameCallFunc()
        animateNode.removeFromParent(false)
        AnimationCachePool.getInstance().backAnimationToPool(animateNode)
    })
}
TileMint.prototype.playMintSpray = function (mainLogic, callBack) {
    let self = this
    self.playReleaseAni(callBack)
    MusicPlayer.stopEffect(self.readyInstance)
    MusicPlayer.playEffect(GameMusicType.kMintFire)
}
TileMint.prototype.onCleanup = function () {
    let self = this;
    if(self.cacheCsbNodes) {
        for(let i = 0;i < self.cacheCsbNodes.length;i++) {
            let csbNode = self.cacheCsbNodes[i];
            if(csbNode) {
                csbNode.removeFromParent(false);
                AnimationCachePool.getInstance().backAnimationToPool(csbNode, true);
                self.cacheCsbNodes[i] = null;
            }
        }
    }
}
module.exports = TileMint
